// extracted by mini-css-extract-plugin
export default {"f":"_2de8113e5e","main":"_0c75d15919","btn":"b0b6732191","w":"_9c68145945","h":"_375a1f0870","lh25":"_6a51489d5a","wb":"d86b8a5b2c","b":"af25d66997","bx":"_70938e4d0f"};